import {
  OPEN_SERVICES_TOTAL_GET,
  SERVICES_BY_TYPE_AND_PLACE_GET,
  AVERAGE_SERVICE_TIME_GET
} from "./mutation-types";
export default {
  [OPEN_SERVICES_TOTAL_GET](state, data) {
    state.openServicesAtWork = data.service;
    state.openServicesAtWorkshop = data.counter;
  },
  [SERVICES_BY_TYPE_AND_PLACE_GET](state, data) {
    switch (data.type) {
      case "Correctivo":
        if (data.place == "Taller") {
          state.chartOptionsWorkshopCorrect.series[0].data = data.counter;
          state.higherThanTwentyCorrect = data.higher;
          state.lowerThanTwentyCorrect = data.lower;
        } else {
          state.chartOptionsWorkCorrect.series[0].data = data.counter;
          state.higherThanOneCorrectField = data.moreThanADay;
          state.lowerThanOneCorrectField = data.lessThanADay;
        }
        break;
      case "Preventivo":
        if (data.place == "Taller") {
          state.chartOptionsWorkshopPrevent.series[0].data = data.counter;
          state.higherThanOnePrevent = data.moreThanADay;
          state.lowerThanOnePrevent = data.lessThanADay;
        } else {
          state.chartOptionsWorkPrevent.series[0].data = data.counter;
          state.higherThanOnePreventField = data.moreThanADay;
          state.lowerThanOnePreventField = data.lessThanADay;
        }
        break;
    }
  },
  [AVERAGE_SERVICE_TIME_GET](state, data) {
    switch (data.place) {
      case "Obra":
        switch (data.type) {
          case "Preventivo":
            state.averagePreventiveWork = data.average;
            break;
          case "Correctivo":
            state.averageCorrectiveWork = data.average;
            break;
        }
        break;
      case "Taller":
        switch (data.type) {
          case "Preventivo":
            state.averagePreventiveWorkshop = data.average;
            break;
          case "Correctivo":
            state.averageCorrectiveWorkshop = data.average;
            break;
        }
        break;
    }
  }
};
